module.exports = __webpack_public_path__ + "img/E-MAIL.c91e18cd.svg";